/* eslint-disable no-trailing-spaces */
/* eslint no-console: 0 */
/* eslint max-len: 0 */

import './vendors';


// import utils from './utils';

// Widgets

import {loadClass} from './loadClass';

let NS = 'bc';
window[NS] = {};

$(document).ready(function() {
	// loadClass('sectionAccordion', 'widget', document.body, true).then((wgAll) => {
	// 	wgAll.length > 0 ? wgAll.forEach((wg) => {
	// 		wg.init();
	// 	}) : '';
	// }).catch((error) => error + 'An error occurred while loading the sectionAccordion widget');
	loadClass('epiServerFormWidget', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the epiServerFormWidget');

	loadClass('weather', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the weather');

	loadClass('intranetListingSearchBar', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the intranetListingSearchBar');

	loadClass('intranetPagination', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the intranetPagination');

	loadClass('intranetFavourites', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the intranetFavourites');

	loadClass('intranetAlert', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the alert');

	loadClass('pagination', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the pagination');

	loadClass('claimForm', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the pagination');

	loadClass('intranetSearchAutoComplete', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the intranetSearchAutoComplete');

	loadClass('generalSearchAutoCompleteWidget', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the generalSearchAutoCompleteWidget');

	loadClass('loginButton', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the loginButton');

	loadClass('accordion', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the accordion');

	loadClass('wzModal', 'widget', document.body, true).then((wgAll) => {
		wgAll.length > 0 ? wgAll.forEach((wg) => {
			wg.init();
		}) : '';
	}).catch((error) => error + 'An error occurred while loading the wzModal');

	loadClass('siteHeader', 'block', document.body, true).then((blAll) => {
			blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
			}) : '';
	}).catch((error) => `${error} An error occurred while loading the siteHeader`);

	loadClass('mapViewBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the mapViewBlock`);

	loadClass('locationSearchResult', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the locationSearchResult`);

	loadClass('addressSearchBar', 'block', document.body, true).then((blAll) => {
			blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
			}) : '';
	}).catch((error) => `${error} An error occurred while loading the addressSearchBar`);

	loadClass('promotionContainer', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the promotionContainer`);

	loadClass('relatedContentBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the relatedContentBlock`);

	loadClass('locationTopSearchBarBlock', 'block', document.body, true).then((blAll) => {
			blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
			}) : '';
	}).catch((error) => `${error} An error occurred while loading the locationTopSearchBarBlock`);

	loadClass('contentListing', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the contentListing`);

	loadClass('searchDateTimeBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the searchDateTimeBlock`);

	loadClass('locationSearchContainer', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the locationSearchContainer`);

	// simpleLocationSearchContainer will replace old locationSearchContainer
	loadClass('simpleLocationSearchContainer', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the simpleLocationSearchContainer`);

	loadClass('videoBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the videoBlock`);

	loadClass('videoListingBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the videoListingBlock`);

	loadClass('imageGalleryBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the imageGalleryBlock`);

	loadClass('testimonialBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the testimonialBlock`);

	loadClass('focalPointImageBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the focalPointImageBlock`);

	loadClass('searchListBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the searchListBlock`);

	loadClass('searchContainerBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the searchContainerBlock`);

	loadClass('subscriptionBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the subscriptionBlock`);

	loadClass('parkingDetailsHeroBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the parking details hero block`);

	loadClass('parkingServiceBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the parking service block`);

	loadClass('directionsBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the directions block`);

	loadClass('bookABay', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the bookABay block`);

	loadClass('serviceTileItemBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the serviceTileItemBlock`);

	loadClass('directionModalBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the directionModalBlock`);

	loadClass('nearbyEventContainerBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the nearbyEventContainerBlock`);


	loadClass('monthlyParkingQuoteForm', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the monthlyParkingQuoteForm`);

	loadClass('quoteBrochureForm', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the quoteBrochureForm`);

	loadClass('accordionFilterBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the accordionFilterBlock`);

	loadClass('accordionBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the accordionBlock`);

	loadClass('intranetSiteHeader', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetSiteHeader`);

	loadClass('intranetNewsCarousel', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetNewsCarousel`);

	loadClass('intranetStaffBirthday', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetStaffBirthday`);

	loadClass('intranetElt', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetElt`);

	loadClass('intranetOrgChart', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetOrgChart`);

	// Generic search part starts
	loadClass('intranetGenericListing', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetGenericListing`);

	loadClass('intranetGenericSearchContainer', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetGenericSearchContainer`);

	loadClass('intranetGenericLeftSearchMenu', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetGenericLeftSearchMenu`);

	loadClass('bookAGuardForm', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the bookAGuardForm`);

	loadClass('SecurityPaymentStep1', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the SecurityPaymentStep1`);

	loadClass('SecurityPaymentStep2', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the SecurityPaymentStep2`);

	loadClass('intranetOfficeListingBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetOfficeListingBlock`);

	loadClass('intranetOfficeSimpleMap', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetOfficeSimpleMap`);

	loadClass('monthlyRecommendedParking', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the monthlyRecommendedParking`);

	loadClass('bookOnlineBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the bookOnlineBlock`);

	loadClass('locationDetail', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
			bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the locationDetail`);

	loadClass('availableParkingForm', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the available parking form`);

	loadClass('carParkSearchBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the car park search block`);

	loadClass('carParkMapBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the car park map block`);

	loadClass('popularCarParkBlock', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the popular car park block`);

	loadClass('subscriptionHeader', 'block', document.body, true).then((blAll) => {
		blAll.length > 0 ? blAll.forEach((bl) => {
				bl.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the subscription header`);
	// pages

	loadClass('searchPage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the searchPage`);

	loadClass('parkingLocationSearchPage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the parkingLocationSearchPage`);

	loadClass('intranetArticleSearchPage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the intranetArticleSearchPage`);

	loadClass('parkingHomePage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the parkingHomePage`);

	loadClass('subscriptionRegistrationPage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the subscriptionRegistrationPage`);

	loadClass('requestAQuotePage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the requestAQuotePage`);

	loadClass('subscriptionRedeemAQuotePage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the subscriptionRedeemAQuotePage`);

	loadClass('subscriptionLandingPage', 'page', document.body, true).then((pgAll) => {
		pgAll.length > 0 ? pgAll.forEach((pg) => {
				pg.init();
		}) : '';
	}).catch((error) => `${error} An error occurred while loading the subscriptionLandingPage`);
	// Theme switcher
	themeSwitcher();
});

// Theme switcher(portable svelte component) enables user to switch theme in development and FE build surge.sh site
function themeSwitcher() {
	const baseUrl = document.location.host;
	if(baseUrl.indexOf('localhost:4') > -1 || baseUrl.indexOf('surge.sh') > -1 || baseUrl.indexOf('192') > -1) {
		import(
			/* webpackChunkName:"theme-switcher" */
			/* webpackMode: "lazy" */
			`global/svelte/ThemeSwitcher.svelte`).then((ts) => {
				const ThemeSwitcher = ts.default;
				const TS = new ThemeSwitcher({
					target: document.body,
					data: {
						// Add all available themes here:
						'themes': [
							{
								'name': 'Parking',
								'filename': 'styles-parking.css',
							},
							{
								'name': 'Group',
								'filename': 'styles-group.css',
							},
							{
								'name': 'Security',
								'filename': 'styles-security.css',
							},
							{
								'name': 'Mack',
								'filename': 'styles-mack.css',
							},
							{
								'name': 'PES',
								'filename': 'styles-pes.css',
							},
							{
								'name': 'Intranet',
								'filename': 'styles-intranet.css',
							},
							{
								'name': 'First Security',
								'filename': 'styles-first-security.css',
							},
						],
						// Timeout for loading theme overlay is displayed
						'loadingDelay': 820,
					},
				});
		});
	}
}


import './page';
